<template>
    <div class="consent" v-if="consent === 'not_accepted'">
      <div class="consent-wrapper">
        <h3 v-html="$root.t(`consent:title`)"></h3>
        <div class="alert" v-html="$root.t(`consent:text`)"></div>
        <input @click="accept()" style="margin-top: 1rem; width: 100%;" type="submit" :value="$root.t('consent:submit')">
      </div>
    </div>
</template>


<script>


export default {
  name: 'Consent',
  props: [],
  data() {
      return {
        consent: false
      }
  },
  created: async function() {
    let settings = await this.$store.dispatch('get_cookie')
    this.consent = settings.data
    console.log(this.consent)
  },
  methods: {
    accept: async function() {
        let settings = await this.$store.dispatch('set_cookie')
        this.consent = settings.data
        console.log(this.consent)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@import '../main';

.consent {
    position: fixed;
    z-index: 10000;
    bottom: $padding;
    right: $padding;
    display: flex;
    .close {
        position: absolute;
        right: $padding;
        top: $padding / 2;
    }
    h3 {
        margin: 0;
    }
    .alert {
        padding-top: $padding;
        @include smallfont;
        a {
            border-bottom: 1px solid;
        }
    }
    &-wrapper {
        background: $active-color;
        max-width: $screen-sm-min;
        color: white;
        margin: auto;
        padding: $padding;
        position: relative;
    }
}
</style>
